import { call, put } from 'redux-saga/effects';

import { apiGeneral, queryBuilder, notify } from 'services';
import { requestErrorHandler } from 'utils';
import { ListReportColumnConfigsActions } from 'store/ducks/settings/configs/list-report-column-configs';

export function* listReportColumnConfigsRequest() {
  try {
    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/report-column-configs`
    );

    const { columnConfigs } = responseBody;

    yield put(ListReportColumnConfigsActions.success(columnConfigs));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(ListReportColumnConfigsActions.failure(errorMessage));
  }
}
